<template>
  <div
    class="content-recipe-block"
    :class="{'in-list': inList}"
  >
    <div class="content-recipe-block__image-wrapper">
      <cloudinary-picture
        :url="imageUrl"
        :sizes="dimensions"
        :sharpen="80"
        auto-quality="best"
        :use-picture="false"
        :aspect-ratio="aspectRatio"
        :link-url="recipe.url"
        :alt="recipe.title"
        class="content-recipe-block__image"
      />
      <save-recipe-button-wrapper
        :recipe="recipe"
        :is-saved="recipe.userInteraction && recipe.userInteraction.recipeSaved"
        :button-size="48"
      />
      <div class="grid--sm-down-hidden content-recipe-block__summery">
        <div
          v-if="cookingTimeText"
          :aria-label="recipe.cookingTime + ' att tillaga'"
          class="content-recipe-block__summery-item"
        >
          <span aria-hidden="true">
            <svgicon
              class="content-recipe-block__summery-icon"
              name="Time/Time"
            />
            {{ cookingTimeText }}
          </span>
        </div>
        <div
          :aria-label="recipe.numberOfIngredients + ' ingredienser'"
          class="content-recipe-block__summery-item"
        >
          <span aria-hidden="true">
            <svgicon
              class="content-recipe-block__summery-icon"
              name="Cooking/Groceries"
            />
            {{ recipe.numberOfIngredients }} <span>Ingredienser</span>
          </span>
        </div>
        <div
          v-if="recipe.difficulty"
          :aria-label="recipe.difficulty + ' svårighetsgrad'"
          class="content-recipe-block__summery-item"
        >
          <span aria-hidden="true">
            <svgicon
              class="content-recipe-block__summery-icon"
              :name="cookingLevelIcon[recipe.difficulty]"
            />
            <span>{{ recipe.difficulty }}</span>
          </span>
        </div>
      </div>
    </div>
    <div class="content-recipe-block__content-wrapper">
      <div class="content-recipe-block__title">
        <span class="font-rubrik-2--bold">{{ recipe.title }}</span>
      </div>
      <div class="">
        <recipe-content-attributes
          :customer-rating="recipe.userInteraction && recipe.userInteraction.customerRate"
          :average-rating="recipe.rating.averageRating"
          :number-of-votes="recipe.rating.numberOfVotes"
          :number-of-comments="recipe.numberOfComments"
          :is-good-climate-choice="recipe.isGoodClimateChoice"
          class="content-recipe-block__attr"
        />
      </div>
      <div class="content-recipe-block__preamble">
        {{ recipe.preamble }}
      </div>
      <div
        class="content-recipe-block__summery grid--md-up-hidden"
      >
        <div
          v-if="cookingTimeText"
          :aria-label="recipe.cookingTime + ' att tillaga'"
          class="content-recipe-block__summery-item"
        >
          <span aria-hidden="true">
            <svgicon
              class="content-recipe-block__summery-icon"
              name="Time/Time"
            />
            {{ cookingTimeText }}
          </span>
        </div>
        <div
          :aria-label="recipe.numberOfIngredients + ' ingredienser'"
          class="content-recipe-block__summery-item"
        >
          <span aria-hidden="true">
            <svgicon
              class="content-recipe-block__summery-icon"
              name="Cooking/Groceries"
            />{{ recipe.numberOfIngredients }} <span
              v-if="!$root.currentSizeEquals('xs')"
              class="content-recipe-block__summery-ingr"
            >Ingredienser</span>
          </span>
        </div>
        <div
          v-if="recipe.difficulty"
          :aria-label="recipe.difficulty + ' svårighetsgrad'"
          class="content-recipe-block__summery-item"
        >
          <span aria-hidden="true">
            <svgicon
              class="content-recipe-block__summery-icon"
              :name="cookingLevelIcon[recipe.difficulty]"
            />
            <span>{{ recipe.difficulty }}</span>
          </span>
        </div>
      </div>
      <a
        :href="recipe.url"
        class="button--secondary image-text-block--button button--40 content-recipe-block__button"
      >Gå till recept</a>
    </div>
  </div>
</template>

<script>
import svgicon from "vue-svgicon"
import "#/Cooking/Level1"
import "#/Cooking/Level2"
import "#/Cooking/Level3"
import "#/Cooking/Cooking"
import "#/Cooking/Groceries"
import "#/Time/Time"
import RecipeContentAttributes from '@/vue/components/recipes/recipeContentAttributes.vue'
import SaveRecipeButtonWrapper from '@/vue/components/recipes/saveRecipeButtonWrapper'



  export default {
    name: "ContentRecipeBlock",
    components: {
      svgicon,
      RecipeContentAttributes,
      SaveRecipeButtonWrapper
    },
    props: {
      recipe: {
        type: Object,
        default: () => {}
      },
      inList: {
        type: Boolean,
        default: false
      }
    },
      data () {
    return {
      dimensions: {
        small: {
          width: 767
        },
        medium: {
          width: 480
        },
        large: {
          width: 570
        }
      },
      recipeIsSaved: false,
      isMounted: false,
      cookingLevelIcon: {
        Enkel: 'Cooking/Level1',
        Medel: 'Cooking/Level2',
        Avancerad: 'Cooking/Level3'
      }
    }
  },
  computed: {
    imageUrl () {
      const r = this.recipe
      if(r.imageUrl) {
        return r.imageUrl
      } else if (r.images && r.images.length) {
        for (let i = 0; i < r.images.length; i++) {
          if(r.images[i].size === 'default'){
            return r.images[i].url
          }
        }
        return r.images[0].url
      }
      return ''
    },
    aspectRatio () {
      return this.$root.isSmallViewport ? 100 : 0
    },
        cookingTimeText () {
      if (this.recipe && this.recipe.cookingTime) {
        let time = this.recipe.cookingTime.split("minuter").join("min")
        if(this.$root.currentSizeEquals('xs')) {
          time = time.replace('Över', '<')
          time = time.replace('Under', '>')
          return time
        }
        return time
      }
      return ""
    },
      }

  }
</script>

<style lang="scss">
.content-recipe-block {
  margin-bottom: 3rem;
  padding: 0 2rem;

  &.in-list {
    margin-bottom: 2.5rem;
  }

  @include media-breakpoint-up(md) {
    display: flex;
    flex-direction: row;
    padding: 0 3.75rem;
  }

  @include media-breakpoint-up(lg) {
    padding: 0 5.125rem;
  }

  @include media-breakpoint-up(xl) {
    padding: 0 6.5rem;
  }

  &__image-wrapper {
    position: relative;

    @include media-breakpoint-up(sm) {
      margin-right: 1rem;
    }

    @include media-breakpoint-up(xl) {
      margin-right: 1.5rem;
    }
  }

  &__image {
    display: block;
    width: 100%;
    padding-bottom: 100%;
    position: relative;
    margin-bottom: 1rem;

    @include media-breakpoint-up(sm) {
      margin: 0 0 1rem 0;
    }

    @include media-breakpoint-up(md) {
      width: 10.625rem;
      padding-bottom: 10.625rem;
      margin: 0;
    }

    @include media-breakpoint-up(lg) {
      width: 9.5rem;
      padding-bottom: 9.5rem;
    }

    @include media-breakpoint-up(xl) {
      width: 12rem;
      padding-bottom: 12rem;
    }

    div {
      position: absolute;
      height: 100%;
      width: 100%;
      object-fit: cover;

      @include media-breakpoint-up(md) {
        &.epi-background-container {
          border-radius: 0.25rem 0.25rem 0 0;
        }
      }
    }
  }

  &__attr {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-flow: wrap;
    margin-bottom: 0.5rem;
  }

  &__attr-item {
    margin: 0 0.75rem  0.5rem 0;
  }

  &__title {
    display: block;
    margin-bottom: 0.5rem;
  }

  &__preamble {
    margin-bottom: 1rem;
  }

  &__summery {
    background: #f5faf4;
    padding: 0.875rem 1.75rem;
    color: #2f6147;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: space-evenly;
    text-align: center;
    margin-bottom: 1rem;
    font-weight: 600;

    @media only screen and (min-device-width: 20rem) {
      flex-direction: row;
    }

    @include media-breakpoint-up(md) {
      padding: 0.375rem 1rem;
      flex-direction: column;
      margin-bottom: 0;
      white-space: nowrap;
    }
  }

  &__summery-item {
    padding: 0;
    margin-bottom: 1rem;
    font-size: 0.875rem;

    &:last-of-type {
      margin-bottom: 0;
    }

    @media only screen and (min-device-width: 20rem) {
      margin-bottom: 0;
    }

    @include media-breakpoint-up(sm) {
      width: calc(100% / 3);
    }

    @include media-breakpoint-up(md) {
      margin-bottom: 1rem;
      width: auto;
    }
  }

  &__summery-ingr {
    @media only screen and (min-device-width: 20rem) {
      display: none;
    }

    @include media-breakpoint-up(sm) {
      display: inline;
    }
  }

  &__summery-icon.svg-icon {
    fill: #2f6147;
    width: 1rem;
    height: 1rem;
    margin-bottom: 0.25rem;
    margin-right: 0.25rem;

    @include media-breakpoint-up(sm) {
      margin: 0 0.25rem 0.25rem auto;
    }
  }

  &__button {
    width: 100%;

    @include media-breakpoint-up(md) {
      width: auto;
    }
  }
}

@include media-breakpoint-down(lg) {
  [class*="grid--lg-down-hidden"] {
    display: none;
  }
}

@include media-breakpoint-down(md) {
  [class*="grid--md-down-hidden"] {
    display: none;
  }
}

@include media-breakpoint-down(sm) {
  [class*="grid--sm-down-hidden"] {
    display: none;
  }
}

@include media-breakpoint-up(lg) {
  [class*="grid--lg-up-hidden"] {
    display: none;
  }
}

@include media-breakpoint-up(md) {
  [class*="grid--md-up-hidden"] {
    display: none;
  }
}

@include media-breakpoint-up(sm) {
  [class*="grid--sm-up-hidden"] {
    display: none;
  }
}
</style>
